var RewardUnlockStrategy;
(function (RewardUnlockStrategy) {
    RewardUnlockStrategy["Instant"] = "instant";
    // Branded Purchase will be assumed default, if missing
    RewardUnlockStrategy["BrandedPurchase"] = "brandedPurchase";
})(RewardUnlockStrategy || (RewardUnlockStrategy = {}));
var UserRewardStatus;
(function (UserRewardStatus) {
    UserRewardStatus["Claimed"] = "claimed";
    UserRewardStatus["Available"] = "available";
    UserRewardStatus["Unavailable"] = "unavailable";
})(UserRewardStatus || (UserRewardStatus = {}));
var CheckoutEligibility;
(function (CheckoutEligibility) {
    CheckoutEligibility["NOT_ELIGIBLE"] = "NOT_ELIGIBLE";
    CheckoutEligibility["CLIENT"] = "CLIENT";
    CheckoutEligibility["SERVER_SIDE"] = "SERVER_SIDE";
})(CheckoutEligibility || (CheckoutEligibility = {}));

export { CheckoutEligibility, RewardUnlockStrategy, UserRewardStatus };
//# sourceMappingURL=product.js.map
